import type { TransactionDetailItem, TransactionDetailParams } from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { formatDateRange } from '#/utils'

export const transactionDetailApi = defineApi('operation', ({ prefix }) => {
  function getWalletTransferListParams(
    params: PagingRequest<TransactionDetailParams>,
  ) {
    return {
      transactionId: params.condition?.transactionId,
      nickname: params.condition?.nickname,
      userId: params.condition?.userId
        ? Number(params.condition?.userId)
        : undefined,
      customerId: Number(params.condition?.customerId),
      transactionReason: params.condition?.transactionReason,
      createdTime: formatDateRange(params.condition?.createdTime),
    }
  }
  function getWalletTransferList(
    params: PagingRequest<TransactionDetailParams>,
  ) {
    params = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      condition: getWalletTransferListParams(params),
    }
    return requestClient
      .post(prefix('wallet/listTransferDetails'), params)
      .then((res) => {
        return {
          items:
            res?.list?.map((item: TransactionDetailItem) => ({
              userId: item.userId,
              transactionId: item.transactionId,
              nickname: item.nickname,
              email: item.email,
              createdTime: item.createdTime,
              transactionReason: item.transactionReason,
              amount: item.amount,
              balanceAfterAmount: item.balanceAfterAmount,
              afterCurrentAmount: item.afterCurrentAmount,
              remark: item.remark,
              originCurrency: item.originCurrency,
              originAmount: item.originAmount,
              exchangeRate: item.exchangeRate,
              currency: item.currency,
              customerId: item.customerId,
            })) || [],
          total: res?.total,
        }
      })
  }

  return {
    getWalletTransferList,
    getWalletTransferListParams,
  }
})
